import React from "react";
import type {
  Belonging,
  BelongingValidation,
} from "../../../../application/domain/proc-management";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { getMaxLength } from "../../../../application/domain/proc-management/util/input-max-length";
import { InputNoticeList } from "./input-notice-list";
import { ListInput } from "./list-input";
import { SimpleTextInput } from "./simple-text-input";
import { SimpleTextAreaInput } from "./simple-textarea-input";
import type { InputProps, PathProps } from "./types";

type BelongingInputProps = Belonging &
  InputProps &
  PathProps & { validationErrors?: BelongingValidation };

export const BelongingInput: React.FC<BelongingInputProps> = (props) => {
  const {
    onChange,
    basePath,
    name,
    helpUrl,
    description,
    disabled = false,
    shouldDisplayError = false,
    validationErrors,
  } = props;
  const requireIf = props.requireIf ?? [];
  const requireIfvalidationErrors = validationErrors?.requireIf ?? [];
  return (
    <div>
      <div className="mb-2">
        <FormFieldLabel label="名前" bold={false} required />
        <SimpleTextInput
          onChange={onChange}
          basePath={[...basePath, "name"]}
          value={name}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.name}
          maxLength={getMaxLength("submissionName")}
        />
      </div>

      <div className="mb-2">
        <FormFieldLabel label="説明" bold={false} />
        <SimpleTextAreaInput
          onChange={onChange}
          basePath={[...basePath, "description"]}
          value={description}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.description}
          maxLength={getMaxLength("submissionDescription")}
        />
      </div>

      <div className="mb-2">
        <FormFieldLabel label="ヘルプページURL" bold={false} />
        <InputNoticeList
          notices={["参照すべきページがある場合などは、URLを記入します。"]}
        />
        <SimpleTextInput
          onChange={onChange}
          basePath={[...basePath, "helpUrl"]}
          value={helpUrl}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.helpUrl}
        />
      </div>

      <ListInput
        label="必須となる条件"
        boldLabel={false}
        mb={2}
        component={SimpleTextInput}
        componentProps={requireIf.map((value, i) => ({
          value,
          onChange,
          shouldDisplayError,
          errorMsg: requireIfvalidationErrors[i],
        }))}
        basePath={[...basePath, "requireIf"]}
        onPush={() => {
          onChange([...basePath, "requireIf"], [...requireIf, ""]);
        }}
        onRemove={(i) => {
          onChange(
            [...basePath, "requireIf"],
            [...requireIf.slice(0, i), ...requireIf.slice(i + 1)],
          );
        }}
        disabled={disabled}
        notices={[
          "特定の状況でのみ必要なものがある場合、必須になる条件を指定することができます。",
          "例: 代理人が手続きを行う場合",
        ]}
      />
    </div>
  );
};
